import { SVGProps, JSX } from 'react';

import {
  Button,
  Dropdown,
  DropdownTrigger,
  ChevronDown as ChevronDownIcon,
  DropdownContent,
  DropdownItem,
  ListItemComp,
  ListItemCompLeading,
  Icon,
  ListItemCompContent,
  ListItemCompTitle,
} from '@mesh.ai/rabbit';

import { ACTION_BUTTON_OPTIONS, REVIEW_ACTIONS } from '../constant';

type ActionButtonDropdownProps = {
  id: number;
  moduleLabel: string;
  moduleIcon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  onActionSelect: (actionType: keyof typeof REVIEW_ACTIONS, actionItemId: number) => void;
  isAddedByEmployee: boolean;
  disabled: boolean;
  canCreateGoals: boolean;
  isGoalsModule: boolean;
  goalsModuleCustomName: string | null;
  isEdited: boolean;
};

export const ActionButtonDropdown = ({
  id,
  moduleLabel,
  moduleIcon,
  onActionSelect,
  isAddedByEmployee,
  disabled = false,
  canCreateGoals,
  isGoalsModule,
  goalsModuleCustomName,
  isEdited,
}: ActionButtonDropdownProps) => (
  <Dropdown>
    <DropdownTrigger
      style={{
        width: '100%',
      }}
      asChild
    >
      <Button
        variant="outline"
        iconLeft={moduleIcon}
        iconRight={ChevronDownIcon}
        disabled={disabled}
        className={`action-item-title-dropdown-${id}`}
        style={{
          width: '100%',
          minHeight: '40px',
          height: 'auto',
        }}
      >
        {moduleLabel}
      </Button>
    </DropdownTrigger>
    <DropdownContent
      style={{
        padding: '8px',
        minWidth: '220px',
      }}
      align="start"
    >
      {Object.keys(ACTION_BUTTON_OPTIONS).map((key) => {
        const option = ACTION_BUTTON_OPTIONS[key];
        const { label: optionLabel, Icon: optionIcon, hasAccess, header } = option;
        if (!hasAccess()) return null;
        if (key === REVIEW_ACTIONS.EXPLAIN_WHY && isAddedByEmployee) return null;
        if (key === REVIEW_ACTIONS.EXPLAIN_WHY && isEdited) return null;
        if (key === REVIEW_ACTIONS.GOAL && !canCreateGoals) return null; // don't render goal button if user doesn't have permission

        return (
          <DropdownItem
            onSelect={() => onActionSelect(key as keyof typeof REVIEW_ACTIONS, id)}
            key={optionLabel(isGoalsModule ? goalsModuleCustomName : null)}
          >
            <ListItemComp style={{ padding: 0 }}>
              <ListItemCompLeading>
                <Icon IconSVG={optionIcon} style={{ color: '#333333' }} />
              </ListItemCompLeading>
              <ListItemCompContent>
                <ListItemCompTitle bold={false}>
                  {optionLabel(header === REVIEW_ACTIONS.GOAL ? goalsModuleCustomName : null)}
                </ListItemCompTitle>
              </ListItemCompContent>
            </ListItemComp>
          </DropdownItem>
        );
      })}
    </DropdownContent>
  </Dropdown>
);
